import locale from "@bonliva-crm/locale";
import { ConfirmDialogOptions } from "./ConfirmDialogOptions";
import { ConfirmDialogAction } from "@containers";
import React from "react";
import ArrowBack from "@material-ui/icons/ArrowBack";

export type YesNoCancelResult = "yes" | "no" | "cancel";

export class YesNoCancelDialogOptions extends ConfirmDialogOptions<YesNoCancelResult> {
  actions: Array<ConfirmDialogAction<YesNoCancelResult>> = [
    {
      title: locale.Cancel,
      icon: React.createElement(ArrowBack),
      type: "regular" as const,
      value: "cancel" as YesNoCancelResult,
      style: {
        marginRight: "auto"
      }
    },
    {
      title: locale.No,
      icon: null,
      type: "primary" as const,
      value: "no" as YesNoCancelResult
    },
    {
      title: locale.Yes,
      icon: null,
      type: "primary" as const,
      value: "yes" as YesNoCancelResult
    }
  ];

  constructor(public title: string = locale.AreYouSure) {
    super();
  }
}
